import { useMemo } from 'react'

import { TemplateStatus } from '#/shared/api/generated/communication/models'
import { useListTemplatesApiV1TemplatesGet } from '#/shared/api/generated/communication/theCargoCommunication'
import type { SelectOption } from '#/shared/ui/select'

import type { TemplateType } from './template-types'

const TEMPLATE_PAGE_SIZE = 100

interface UseTemplateOptionsArgs {
  templateType: TemplateType
  enabled?: boolean
}

interface UseTemplateOptionsResult {
  options: SelectOption[]
  isLoading: boolean
}

export function useTemplateOptions({
  templateType,
  enabled = true,
}: UseTemplateOptionsArgs): UseTemplateOptionsResult {
  const query = useListTemplatesApiV1TemplatesGet(
    {
      template_type: templateType,
      status: TemplateStatus.active,
      size: TEMPLATE_PAGE_SIZE,
    },
    { query: { enabled } },
  )
  const items = query.data?.data.items
  const options = useMemo<SelectOption[]>(
    () => (items ?? []).map((item) => ({ value: item.id, label: item.name })),
    [items],
  )
  return { options, isLoading: query.isLoading }
}
